export default __webpack_public_path__ + "static/media/logo.f34823be.png";